import { Component } from '@angular/core';
import { AlertController } from 'ionic-angular';
import {datos} from '../../providers/datos';
import { NavController} from 'ionic-angular';
import { Detalle } from '../detalle/detalle';

declare var swal:any


@Component({
  templateUrl: 'promociones.html',
  selector: 'promociones',
  providers: []
})

export class promociones {

  pagina ={
  "title": "Promociones",
  "boton": "Pruébalo ahora !",
  "sub_titulo": "a la comodidad de su hogar",
   "background": "assets/images/app/fondo.jpg"}

  items=  [

            ];

  // services: array
  constructor(
    private datos:datos,
    public alertCtrl: AlertController,
    public navCtrl: NavController,

  ) {


    this.iniciar();

  }

  selectPageForOpen(value: string): any {
    let page;

    switch (value) {

      case "imageGallery":
        page = "ItemDetailsPageImageGallery";
        break;

        default:
        page = "ItemDetailsPage";
    }

    return page;
  }

  getMenu(lista){
    console.log(lista);
    if(lista.length<1){
      this.datos.Toast("VACíO !!",2000);
      setTimeout(() => {
        this.navCtrl.pop();
      }, 2000);

    }
    for (let i= 0; i<lista.length; i++) {
      setTimeout(() => {
        this.items.push(lista[i]);
      }, 500*i);

    }
  }




  iniciar()
  {
    this.datos.loader(1);
    this.datos.getPagina('app/getPromociones')
               .subscribe((data) => {
                 this.datos.loader(0);
                   this.getMenu(data.data);
                },
               (error: any) => {
                  this.datos.loader(0);
                   console.log(error);
               });
               return 0
  }



  openPage(page: any) {


  }

  navigation(page: any) {


  }

  showPrompt() {

}

modal(item){
  swal("Añadir: "+item.nombre+"?", 
  {
    title: "Añadir servicio ocre",
    text: "Desea añadir: "+item.nombre+ " $"+ String(item.total.toFixed(2)),
    buttons: {
      cancel: "Cancelar!",     
      defeat: {
        text:"OK",
        value:"ok"
      },
    },
  })
  .then((value) => {
    switch (value) {
   
   
      case "ok":
        this.datos.pedido.items.push(item);
        // swal(""+item.nombre+ " $"+ item.total!,"", "success");

                    swal({
                            title: ""+item.nombre+ " $"+ String(item.total.toFixed(2)),
                            text: "Tiene "+this.datos.pedido.items.length+" items en su carrito",
                            icon: "success",
                            confirmButtonColor:"red",
                            buttons: {
                              cancel: "Añadir otro!",     
                              defeat: {
                                text:"("+this.datos.pedido.items.length+") Ir a carrito",
                                value:"ok"
                              },
                            },
                          })
                          .then((value) => {

                            switch (value) {                         
                           
                              case "ok":
                              this.carrito();
                              break;
                              default:
                              console.log("cancelado");
                            }
                          });
                      
        
        break;
  //  fin del ok del primero modal 
      default:
        console.log("cancelado");
    }
  });

  }
  
  carrito() {
    
    this.navCtrl.push(Detalle,{ });
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/promociones/promociones.ts